export const OrderStatusEnum = [
  {
    name: "Draft",
    value: "Order has been received.",
  },
  {
    name: "Order Review",
    value:
      "Order has been sent to kitchen/vendor but has not yet been confirmed.",
  },
  {
    name: "Confirmed",
    value: "Kitchen has confirmed that they can produce the order.",
  },
  {
    name: "Vendor Confirmed",
    value: "Vendor has confirmed that they can produce the order.",
  },
  {
    name: "In production",
    value: "Kitchen is producing the order.",
  },
  {
    name: "Packed",
    value: "Order is packed and ready for delivery.",
  },
  {
    name: "Delivered",
    value:
      "Order has been delivered to delivery location. (There may be a delay on manually confirmed orders.)",
  },
  {
    name: "Pending Cancellation",
    value: "A cancellation request was received and is pending cancellation.",
  },
  {
    name: "Cancelled",
    value: "Order has been cancelled.",
  },
  {
    name: "Invoiced",
    value:
      "Invoice has been generated. Please contact ACW Account for invoice document.",
  },
  {
    name: "Pending payment details",
    value:
      "Order is awaiting Credit Card Authorization before being sent to the Kitchen/Vendor",
  },
  {
    name: "Quote",
    value:
      "Your order is in Quote status. Please reach out to Guest Services to finalize your order for delivery.",
  },
  {
    name: "En Route",
    value: "Your order is en route from the kitchen to the delivery location.",
  },
  {
    name: "Processing",
    value: "Your order is being processed. Please check back soon for updates.",
  },
];

export const OrderStatus = {
  DRAFT: "Draft",
  DELIVERED: "Delivered",
  INVOICED: "Invoiced",
  CANCELLED: "Cancelled",
  CANCELED: "Canceled",
  ORDER_REVIEW: "Order Review",
  PACKED: "Packed",
  PENDING_PAYMENT_DETAILS: "PendingPaymDetails",
  PENDING_CANCELLATION: "Pending Cancellation",
  EN_ROUTE: "En Route",
  IN_ROUTE: "In Route",
  CONFIRMED: "Confirmed",
  IN_PRODUCTION: "In Production",
  QUOTE: "Quote",
};

export const KitchenOrderStatusList = [
  {
    id: "OrderReview",
    value: "Order Review",
  },
  {
    id: "InProduction",
    value: "In Production",
  },
  {
    id: "Packed",
    value: "Packed",
  },
  {
    id: "InRoute",
    value: "En Route",
  },
  {
    id: "Delivered",
    value: "Delivered",
  },
];
